var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{class:_vm.divClasses,style:(_vm.height)},[_c('Icon',{class:_vm.iconClasses,attrs:{"type":"loading"}}),(_vm.text)?_c('p',{attrs:{"className":"sw-loader__text"}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }